function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useMemo } from 'react';
import { compact } from 'lodash';
import { useStateInRef } from "../../../utils/useStateInRef";
import { BiContext, useBiContextGetter } from "../BiContext";
import { jsx as _jsx } from "react/jsx-runtime";
export function BiContainer(_ref) {
  let {
    children,
    name,
    data
  } = _ref;
  const getParent = useBiContextGetter();
  const logBiClick = useCallback(biEvent => {
    var _biEvent$hierarchy;
    const parent = getParent();
    if (!parent) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.warn('[BI] BiContainer used without a BiProvider ancestor');
      }
      return;
    }
    parent.logBiClick({
      entityType: biEvent.entityType,
      entityName: biEvent.entityName,
      actionType: biEvent.actionType,
      data: _objectSpread(_objectSpread({}, data), biEvent.data),
      hierarchy: compact([name, ...((_biEvent$hierarchy = biEvent.hierarchy) !== null && _biEvent$hierarchy !== void 0 ? _biEvent$hierarchy : [])])
    });
  }, [getParent, name, data]);
  const logBiPageView = useCallback(biEvent => {
    const parent = getParent();
    if (!parent) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.warn('[BI] BiContainer used without a BiProvider ancestor');
      }
      return;
    }
    parent.logBiPageView({
      pageName: biEvent.pageName,
      data: biEvent.data
    });
  }, [getParent]);
  const logBiModalView = useCallback(biEvent => {
    var _biEvent$hierarchy2;
    const parent = getParent();
    if (!parent) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.warn('[BI] BiContainer used without a BiProvider ancestor');
      }
      return;
    }
    parent.logBiModalView({
      modalName: biEvent.modalName,
      data: _objectSpread(_objectSpread({}, data), biEvent.data),
      hierarchy: compact([name, ...((_biEvent$hierarchy2 = biEvent.hierarchy) !== null && _biEvent$hierarchy2 !== void 0 ? _biEvent$hierarchy2 : [])])
    });
  }, [getParent, name, data]);
  const startTransaction = useCallback(input => {
    var _input$hierarchy;
    const parent = getParent();
    if (!parent) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.warn('[BI] BiContainer used without a BiProvider ancestor');
      }
      return () => {};
    }
    return parent.startTransaction({
      transactionName: input.transactionName,
      data: _objectSpread(_objectSpread({}, data), input.data),
      hierarchy: compact([name, ...((_input$hierarchy = input.hierarchy) !== null && _input$hierarchy !== void 0 ? _input$hierarchy : [])])
    });
  }, [getParent, name, data]);
  const value = useMemo(() => ({
    logBiClick,
    logBiPageView,
    logBiModalView,
    startTransaction
  }), [logBiClick, logBiPageView, logBiModalView, startTransaction]);
  const getValue = useStateInRef(value);
  return /*#__PURE__*/_jsx(BiContext.Provider, {
    value: getValue,
    children: children
  });
}